(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var qtyInputs = document.querySelectorAll('.be-cart__qty-input');
    qtyInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var form = this.closest('form');
        if (form) form.submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
